import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
function cleanPropPanel() {
  var _top$Gikam;

  var propPanel = (_top$Gikam = top.Gikam) === null || _top$Gikam === void 0 ? void 0 : _top$Gikam.propPanel;

  if (!propPanel) {
    return;
  }

  propPanel.$destroy();
  top.Gikam.removeDom(top.Gikam.propPanel.$el);
  top.Gikam.propPanel = null;
}

var wheel = document.onmousewheel ? 'mousewheel' : 'DOMMouseScroll';
var eventNames = ['mousedown', 'scroll', wheel];
eventNames.forEach(function (item) {
  document.addEventListener(item, function (event) {
    var _top$Gikam2;

    var panel = (_top$Gikam2 = top.Gikam) === null || _top$Gikam2 === void 0 ? void 0 : _top$Gikam2.propPanel;

    if (event.target === document && panel && panel.customEventDestory === false) {
      return;
    }

    cleanPropPanel();
  });
});
window.addEventListener('resize', function () {
  var _top$Gikam3, _top$Gikam3$propPanel;

  return (_top$Gikam3 = top.Gikam) === null || _top$Gikam3 === void 0 ? void 0 : (_top$Gikam3$propPanel = _top$Gikam3.propPanel) === null || _top$Gikam3$propPanel === void 0 ? void 0 : _top$Gikam3$propPanel.refreshPosition();
});
export default {
  props: {
    target: Node,
    top: {
      type: Number,
      default: null
    },
    left: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    minWidth: {
      type: Number,
      default: null
    },
    propStyle: Object,
    listeners: Object,
    customEventDestory: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      react: this.target ? this.target.getBoundingClientRect() : null
    };
  },
  computed: {
    minWidthSize: function minWidthSize() {
      return this.minWidth || this.width;
    },
    styleObject: function styleObject() {
      return _objectSpread({
        top: (this.top || this.react.top) + this.react.height + 'px',
        left: (this.left || this.react.left) + 'px',
        height: this.height ? this.height + 'px' : 'auto',
        minWidth: "".concat(this.minWidthSize, "px")
      }, this.propStyle);
    }
  },
  created: function created() {
    this.clean();
    this.$emit('startEvent');
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$nextTick();

            case 2:
              _this.refreshPosition();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('closeEvent');
  },
  destroyed: function destroyed() {
    this.$emit('destroyed');
  },
  methods: {
    clean: function clean() {
      var _this$listeners, _this$listeners$befor;

      (_this$listeners = this.listeners) === null || _this$listeners === void 0 ? void 0 : (_this$listeners$befor = _this$listeners.beforeClean) === null || _this$listeners$befor === void 0 ? void 0 : _this$listeners$befor.call();
      cleanPropPanel();
    },
    refreshPosition: function refreshPosition() {
      window.top.document.body.style.overflow = 'hidden';
      var offsetPosition = 10;

      var _this$target$getBound = this.target.getBoundingClientRect(),
          usedTopHeight = _this$target$getBound.top,
          targetLeft = _this$target$getBound.left,
          targetWidth = _this$target$getBound.width;

      var usedBottomHeight = document.body.offsetHeight - this.target.offsetHeight - usedTopHeight;
      var pickerHeight = this.$el.offsetHeight;
      var pickerWidth = Math.max(targetWidth, this.minWidthSize);
      var pickerLeft = this.$el.offsetLeft;
      var maxUsedHeight = Math.max(usedTopHeight, usedBottomHeight) - offsetPosition;
      this.$el.style.width = "".concat(targetWidth, "px");

      if (pickerHeight < usedBottomHeight) {
        this.$el.style.top = "".concat(usedTopHeight + this.target.offsetHeight, "px");
      }

      if (pickerHeight > usedBottomHeight && pickerHeight < usedTopHeight) {
        this.$el.style.top = "".concat(usedTopHeight - pickerHeight - 10, "px");
      }

      if (pickerHeight > usedBottomHeight && pickerHeight > usedTopHeight) {
        this.$slots.default[0].elm.style.maxHeight = "".concat(maxUsedHeight, "px");

        if (usedTopHeight > usedBottomHeight) {
          this.$el.style.top = "".concat(offsetPosition - 10, "px");
        } else {
          this.$el.style.top = "".concat(usedTopHeight + this.target.offsetHeight - 5, "px");
        }
      }

      if (pickerWidth + pickerLeft > document.body.offsetWidth) {
        this.$el.style.left = "".concat(targetLeft + targetWidth - pickerWidth, "px");
      } else {
        this.$el.style.left = "".concat(targetLeft, "px");
      }

      if (window !== window.top) {
        var iframeRect = window.top.document.body.querySelector("[name='".concat(window.name, "']")).getBoundingClientRect();
        this.$el.style.top = parseInt(this.$el.style.top) + iframeRect.top + 'px';
        this.$el.style.left = parseInt(this.$el.style.left) + iframeRect.left + 'px';
      }

      window.top.document.body.style.overflow = '';
      top.Gikam.propPanel = this;
    }
  }
};